import { useState } from "react";
import axiosInstance, { api } from "../common/api";
import { Input, InputNumber, Select } from "antd";
import TablePage from "../components/TablePage";
import SimpleTablePage from "../common/SimpleTablePage";
import { Link } from "react-router";

const columns = [
  {
    title: "ID",
    ellipsis: true,
    defaultSortOrder: "ascend",
    key: "id",
    dataIndex: "id",
    width: 70,
    render: (id) => <Link to={`${id}`}>{id}</Link>,
  },
  {
    title: "Nome",
    key: "name",
    dataIndex: "name",
    sorter: true,
    ellipsis: true,
    width: 250,
  },
  {
    title: "Tracciamento",
    key: "trackingType",
    sorter: true,
    dataIndex: "trackingType",
    ellipsis: true,
  },
];

const formItems = [
  {
    label: "ID",
    name: "id",
    formItem: {
      children: <InputNumber style={{ width: "100%" }} controls={false} precision={0} />,
    },
  },
  {
    label: "Nome",
    name: "name",
    formItem: {
      children: <Input />,
    },
  },
  {
    name: "trackingType",
    label: "Tracciamento",
    readableValue: (value) =>
      ({
        SERIAL: "Matricola",
        QUANTITY: "Quantità",
      })[value],
    formItem: {
      children: (
        <Select
          showSearch
          allowClear
          options={[
            { label: "Matricola", value: "SERIAL" },
            { label: "Quantità", value: "QUANTITY" },
          ]}
        />
      ),
    },
  },
];

export default function DpiTypes() {
  return (
    <SimpleTablePage
      title="DPI"
      description={"Crea, modifica ed elimina le categorie di DPI"}
      resource={"dpi"}
      columns={columns}
      filterItems={formItems}
    />
  );
}
